// extracted by mini-css-extract-plugin
export default {"container":"Headers_container_jpEos","content":"Headers_content_QV4bX","column":"Headers_column_tac9u","edit":"Headers_edit__V1sk"};